/** Web/PWA taslak deposu: IndexedDB (Dexie). Görseller Blob olarak saklanır. */
import Dexie, { type Table } from 'dexie';
import type { Draft, DraftStore } from './types';

interface ImageRow { key: string; draftId: string; blob: Blob }

class DraftDb extends Dexie {
  drafts!: Table<Draft, string>;
  images!: Table<ImageRow, string>;

  constructor() {
    super('aksan-drafts');
    this.version(1).stores({
      drafts: 'id, userId, state, updatedAt',
      images: 'key, draftId',
    });
  }
}

export class WebDraftStore implements DraftStore {
  private db = new DraftDb();

  async list(userId: string): Promise<Draft[]> {
    return (await this.db.drafts.where('userId').equals(userId).toArray()).sort((a, b) => b.updatedAt - a.updatedAt);
  }

  get(id: string) {
    return this.db.drafts.get(id);
  }

  async put(draft: Draft) {
    await this.db.drafts.put({ ...draft, updatedAt: Date.now() });
  }

  async remove(id: string) {
    await this.db.transaction('rw', this.db.drafts, this.db.images, async () => {
      await this.db.images.where('draftId').equals(id).delete();
      await this.db.drafts.delete(id);
    });
  }

  async putImage(draftId: string, imageId: string, blob: Blob) {
    await this.db.images.put({ key: `${draftId}:${imageId}`, draftId, blob });
  }

  async getImage(draftId: string, imageId: string) {
    return (await this.db.images.get(`${draftId}:${imageId}`))?.blob;
  }

  async removeImages(draftId: string) {
    await this.db.images.where('draftId').equals(draftId).delete();
  }
}
